import "./giftcardratetable.css";
import Button from "../button/Button";
import UK from "../../assets/UK-flag.png";
import USD from "../../assets/USD.png";
import CAD from "../../assets/CAD.png";
import AUD from "../../assets/AUD.png";
import NZD from "../../assets/NZD.png";
import CHF from "../../assets/CHF.png";
import SGD from "../../assets/SGD.png";
import EUR from "../../assets/EUR.png";

import { useState, useEffect } from "react";
import LazyLoad from "react-lazyload";
import { useCalculatorModal } from "../../context/CalculatorContext";

// Mapping of currency names to their corresponding flag images
const currencyFlags = {
  USD,
  UK,
  CAD,
  AUD,
  NZD,
  CHF,
  SGD,
  EUR,
};

const GiftCardRateTable = ({ logo, cardName, list }) => {
  const [currencyIndex, setCurrencyIndex] = useState(0);
  const { openCalculator } = useCalculatorModal();

  const handleClick = (index) => {
    setCurrencyIndex(index); // Update the state
  };

  useEffect(() => {}, [currencyIndex]);

  const handleCalculateClick = () => {
    const activeCurrency = list && list[currencyIndex] ? list[currencyIndex].currency : "USD";
    openCalculator({
      card_name: cardName,
      currency: activeCurrency,
    });
  };

  return (
    <div
      className="container my-4 p-4 shadow rounded-4 GiftCard_card"
      style={{ width: "85%", border: "0.5px solid #BFBFBF" }}
    >
      {/* Header Section */}
      <h4>{cardName}</h4>
      <div className="row align-items-center mb-4">
        {/* Flag Section */}
        <div className="col-12 col-md-8">
          <div className="flag-container d-flex flex-wrap justify-content-center justify-content-md-start align-items-center gap-2 mt-2 flag-container">
            {list.map((item, index) => (
              <div
                key={index}
                className={`flag ${currencyIndex === index ? "active" : ""}`} // Add active class dynamically
                onClick={() => handleClick(index)}
              >
                <img
                  src={currencyFlags[item.currency]} // Dynamically get the corresponding flag image
                  alt={item.currency}
                  style={{ width: "20px", height: "auto" }}
                />
                {item.currency}
              </div>
            ))}
          </div>
        </div>

        {/* Calculate Button */}
        <div className="col-12 col-md-4 d-flex justify-content-md-end justify-content-center mt-2 mt-md-0">
          <Button
            className="btn w-50 w-md-50 hover-effect mbtn d-flex align-items-center justify-content-center"
            id="calculateBtn"
            onClick={handleCalculateClick}
          >
            <i className="bi bi-calculator me-2"></i>Calculate
          </Button>
        </div>
      </div>

      {/* Content Section */}
      <div className="row">
        {/* Image Section */}
        <div
          className="col-12 col-md-3 text-center mb-3 mb-md-0"
          style={{ height: "80%" }}
        >
          <LazyLoad>
            <img
              src={logo}
              alt="GiftCard"
              className="w-100 img-fluid rounded hover-effect cardImg "
            />
          </LazyLoad>
        </div>

        {/* Table Section */}
        <div className="col-12 col-md-9">
          <div className="desktopTable" style={{ overflowX: "auto" }}>
            <table
              className="table rounded-table text-center"
              style={{ border: "0.5px solid #BFBFBF" }}
            >
              <tbody>
                <tr>
                  <td className="fw-bold p-4">Face Value</td>
                  {list[currencyIndex].list.map((item, index) => (
                    <td key={index} className="p-4">
                      {item.name}
                    </td>
                  ))}
                </tr>
                <tr>
                  <td className="fw-bold p-4">Rate</td>
                  {list[currencyIndex].list.map((item, index) => (
                    <td key={index} className="p-4">{`${item.rate}₦/$`}</td>
                  ))}
                </tr>
              </tbody>
            </table>
          </div>
          <div className="mobileTable mt-4" style={{ display: "none" }}>
            <table
              className="table rounded-table text-center"
              style={{ border: "0.5px solid #BFBFBF" }}
            >
              <thead>
                <tr>
                  <th className="p-4">Face Value</th>
                  <th className="p-4">Rate</th>
                </tr>
              </thead>
              <tbody>
                {list[currencyIndex].list.map((item, index) => (
                  <tr key={index}>
                    <td className="p-4">{item.name}</td>
                    <td className="p-4">{`${item.rate}₦/$`}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GiftCardRateTable;
